import { createSelector } from 'reselect'
import _ from 'lodash'

const getToursCount = (state = {}) => {
  const tours = state.tours
  return _.size(tours)
}

const getToursEnabled = (state = {}) => {
  return state.misc.toursEnabled
}

const checkShowTours = createSelector(
  [ getToursCount, getToursEnabled ],
  (toursCount, toursEnabled) => (
    toursEnabled &&
    toursCount > 0
  ),
)

export default checkShowTours
